import { requests } from '../../helper/agent';
import {
  SUPPRESSED_SHORTFALL_LIST_ERROR,
  SUPPRESSED_SHORTFALL_LIST_RECEIVED,
  SUPPRESSED_SHORTFALL_LIST_REQUEST,
  SUPPRESSED_SHORTFALL_LIST_SET_PAGE,
  SUPPRESSED_SHORTFALL_LIST_UNLOAD,
} from '../constants';

import * as API_ROUTES from '../../routing/api';
import { userLogout } from './user';

/**
 * MED-1002 - shortfalls a patient was never told about.
 *
 * Reads only, and there is nothing to add. The API exposes GetCollection and Get and no write
 * operation at all: a record of what was withheld that staff can edit or remove is not evidence.
 * Clearing the suppression is done on the patient screen by clearing `noShortfall`, which leaves
 * this list exactly as it was - which is the point of recording the event rather than deriving
 * the list from the flag.
 */

export const suppressedShortfallListRequest = () => ({
  type: SUPPRESSED_SHORTFALL_LIST_REQUEST,
});

export const suppressedShortfallListReceived = (data) => ({
  type: SUPPRESSED_SHORTFALL_LIST_RECEIVED,
  data,
});

export const suppressedShortfallListError = (error) => ({
  type: SUPPRESSED_SHORTFALL_LIST_ERROR,
  error,
});

export const suppressedShortfallListSetPage = (page) => ({
  type: SUPPRESSED_SHORTFALL_LIST_SET_PAGE,
  page,
});

export const suppressedShortfallListUnload = () => ({
  type: SUPPRESSED_SHORTFALL_LIST_UNLOAD,
});

/**
 * Paginated, and newest first by default from the API's own ordering.
 *
 * Suppression is meant to be rare, so this list should be short - but it is the record of every
 * patient who was never chased, and it only ever grows. Pulling the lot is the habit that made
 * the patient index slow to write; it is not repeated here.
 *
 * A 403 is left to fall into the error state rather than handled specially: consultant-side users
 * are refused this endpoint outright, and the route guard means they never reach the screen that
 * mounts this in the first place.
 */
export const suppressedShortfallListFetch = (page = 1) => {
  return (dispatch) => {
    dispatch(suppressedShortfallListRequest());

    return requests
      .get(API_ROUTES.SUPPRESSED_SHORTFALLS, { pagination: true, page })
      .then((response) => dispatch(suppressedShortfallListReceived(response)))
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return dispatch(userLogout());
        }
        dispatch(suppressedShortfallListError(error));
      });
  };
};
